import React from 'react';
import { HelpSnippet } from 'br2s-ui-componentlibrary_r2_02';
import Richtext from '../Richtext/Richtext';

export interface HelpSnippetProps {
  /**
   * id of the help snippet
   */
  id: string;
  /**
   * Title of the help snippet
   */
  title: string;
  /**
   * Content of the help snippet. Will be displayed if help snippet expanded
   */
  content: string,
}

function HelpSnippetAdapter({
  id,
  title,
  content,
}: HelpSnippetProps) {

  return (
    <HelpSnippet 
      id={id}
      title={title}
    >
      <Richtext content={content} />
    </HelpSnippet>
  );
}

export default HelpSnippetAdapter;
